import { useAuth } from "@clerk/clerk-react";
import { Navigate, useLocation } from "react-router-dom";
import React, { type PropsWithChildren } from "react";
import LoadingScreen from "@/hooks/components/common/LoadingScreen.tsx";

export const AuthGuard: React.FC<PropsWithChildren> = ({ children }) => {
    const { isLoaded, isSignedIn } = useAuth();
    const location = useLocation();

    if (!isLoaded) {
        return <LoadingScreen />;
    }

    if (!isSignedIn) {
        return <Navigate to="/auth/login" state={{ from: location.pathname }} replace />;
    }

    return <>{children}</>;
};